<template>
  <div class="wardrobe-dropdown-container">
    <b-dropdown
      id="wardrobe-dropdown"
      :text="selectedText"
      :class="[similar ? 'similar' : 'exact']"
      variant="outline-unstitched"
    >
      <b-dropdown-item
        v-for="(option, index) in options"
        :key="index"
        @click="makeSelection(option)"
        :disabled="selectedText === option"
      >
        {{ option }}
      </b-dropdown-item>
      <b-dropdown-divider v-if="isAlreadyInWardrobe" />
      <b-dropdown-item v-if="isAlreadyInWardrobe" @click="removeSelection()">
        Remove from wardrobe
      </b-dropdown-item>
    </b-dropdown>
    <div>
      <small
        class="form-text text-muted mb-3 action-text"
        :class="{ 'show-action-text': showActionText }"
        v-html="actionText"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      options: ["I own this", "I own similar"],
      showActionText: false,
      actionText: ""
    };
  },

  props: {
    productId: {
      type: Number,
      required: true
    },

    wardrobeId: {
      type: Number,
      required: true
    },

    group: {
      type: String,
      required: true
    },

    similar: {
      type: Boolean,
      required: false,
      default: null
    }
  },

  computed: {
    selectedText() {
      return !this.isAlreadyInWardrobe
        ? "Add to wardrobe"
        : this.similar
        ? "I own similar"
        : "I own this";
    },

    isAlreadyInWardrobe() {
      return this.similar !== null;
    }
  },

  methods: {
    ...mapActions([
      "addWardrobeProduct",
      "updateWardrobeProduct",
      "removeWardrobeProduct"
    ]),

    makeSelection(option) {
      if (this.selectedText === option) return;

      const isSimilar = option == "I own similar";
      const text = isSimilar ? "Similar" : "Exact";

      const payload = {
        wardrobeId: this.wardrobeId,
        productId: this.productId,
        similar: isSimilar,
        group: this.group
      };

      this.isAlreadyInWardrobe
        ? this.updateWardrobeProduct(payload)
        : this.addWardrobeProduct(payload);

      this.displayActionText(`<span><b>Added</b> to wardrobe (${text})`);
    },

    removeSelection(option) {
      const payload = {
        wardrobeId: this.wardrobeId,
        productId: this.productId
      };

      this.removeWardrobeProduct(payload);
      this.displayActionText(
        '<span class="action-text-removed"><b>Removed</b> from wardrobe</span>'
      );
    },

    displayActionText(text) {
      this.actionText = text;
      this.showActionText = true;

      setTimeout(() => {
        this.showActionText = false;
      }, 2000);
    }
  }
};
</script>

<style lang="scss">
@import "~@/styles/_colour-palette.scss";

#wardrobe-dropdown {
  margin-left: 0 !important;

  &.show > button {
    color: white;
    box-shadow: none;
  }

  &.exact > button {
    background-image: linear-gradient(
        rgba(255, 255, 255, 0),
        rgba(255, 255, 255, 0)
      ),
      linear-gradient(101deg, #ff5e62, #ff9966);
  }

  &.similar > button {
    background-image: linear-gradient(
        rgba(255, 255, 255, 0),
        rgba(255, 255, 255, 0)
      ),
      linear-gradient(101deg, #0ed2f7, #b2fefa);
  }

  button {
    border-color: $grey4;
    color: $grey3;

    color: $primary-blue;
    box-shadow: 0 0 6px 0 rgba(157, 96, 212, 0.5);
    border: solid 1px transparent;
    background-origin: border-box;
    background-clip: content-box, border-box;
    box-shadow: 2px 1000px 1px #fff inset;

    &:hover,
    &:active {
      box-shadow: none;
      color: white;
    }
  }

  .dropdown-toggle:after {
    margin-left: 0.5em;
  }
}

.action-text {
  color: $emerald !important;
  opacity: 0;
  transition: all 0.3s linear;
}

.action-text-removed {
  color: $alizarin;
}

.show-action-text {
  opacity: 1 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/wardrobe/AddRemoveWardrobeDropdown.vue